import React from 'react'
import renderHTML from 'react-render-html';
import './style.css'

export default (props) =>{
    console.log('asdoiasjdioasjdiojasiodjas', props)
    return(
        <div className='reminder_'>
            <div className='reminder_text'>
                {renderHTML(props.texto)}
            </div>

            <div className='reminder_info'>
                <span className='info_telefone'>
                    Telefone : {props.telefone.join(', ')}
                </span>

                <span className='info_endereco'>
                    Endereço de stand : {props.endereco}
                </span>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/views/website/reminder/component.js